import gql from "graphql-tag";

export const GET_REFFERAL_LINK = gql`
  query referral_links {
    referral_links {
      referral_id
    }
  }
`;
